




































import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { InputUserUpdate, User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { checkRole } from "@teacherskaya/tools/dist/lib/SecurityHelpers";
import { FormValues } from "@/types";
import config from "@/config";
import WithLoggedInUser from "@/mixins/WithLoggedInUser";
import WithEmailVerification from "@/mixins/WithEmailVerification";
import WrapperCheckAuthorities from "@/components/WrapperCheckAuthorities.vue";
import BlockBase from "@/components/BlockBase.vue";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import BlockBaseView from "@/components/BlockBaseView.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import { fields } from "./config";

@Component({
  name: "BlockProfileInformation",
  components: { ModalConfirm, WrapperCheckAuthorities, BlockBaseView, BlockBase, BlockBaseForm },
})
export default class BlockProfileInformation extends mixins(WithLoggedInUser, WithEmailVerification) {
  @Prop({ required: true })
  public user!: User;

  public title = "Profile Information";

  public editing = false;

  public verified: boolean | null = null;

  public codeResended = false;

  public get emailOptionStyle() {
    return { position: (!config.featurePhoneSignUp && !this.$vuetify.breakpoint.smAndDown && "absolute") || "" };
  }

  public get filteredFields() {
    if (checkRole(this.user.role || "", "creator")) {
      return fields;
    }
    return fields.filter(i => i.name !== "domain");
  }

  get fields() {
    const user = this.user;
    return this.filteredFields
      .map(item => {
        item.value = item.name === "timeZone" ? user.accountInfo.timeZone : user[item.name as keyof User];
        if (!config.featurePhoneSignUp && ["timeZone"].includes(item.name)) {
          item.flexClass = "offset-md-6 col-12 col-md-6 mb-2";
        }
        if (["domain"].includes(item.name)) {
          item.flexClass = "offset-md-6 col-12 col-md-6 mb-2";
        }
        return item;
      })
      .filter(item => item.name !== "role" || this.user.id !== this.loggedInUser.id.toString());
  }

  @Watch("user")
  public onUserChanges() {
    this.editing = false;
  }

  public async save(values: FormValues) {
    let data: InputUserUpdate = {
      id: this.user.id,
      username: values.username,
      screenName: values.screenName,
      timeZone: values.timeZone,
      role: values.role,
    };
    if (config.featurePhoneSignUp && values.phone !== this.user.phone) {
      data = { ...data, phone: values.phone };
    }
    if (this.user.email !== null && values.email !== this.user.email) {
      data = { ...data, email: values.email };
    }
    this.$emit("updateUser", data);
  }

  public async setVerified() {
    this.verified = await this.emailVerificationSetVerified(this.user.id);
  }

  public async startVerification() {
    this.verified = !(await this.emailVerificationStart(this.user.id));
    this.codeResended = true;
  }

  public mounted() {
    this.emailVerificationFindById(this.user.id).then(r => (this.verified = r));
  }
}
